import { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { useAuthStore } from '../stores/authStore';
import { useProgrammeStore } from '../stores/programmeStore';

export function Layout() {
  const [collapsed, setCollapsed] = useState(false);
  const { isAuthenticated } = useAuthStore();
  const { loadProgrammes } = useProgrammeStore();

  // Load programmes when authenticated
  useEffect(() => {
    if (isAuthenticated) {
      loadProgrammes();
    }
  }, [isAuthenticated, loadProgrammes]);

  return (
    <div className="min-h-screen bg-[#F5F5F5]">
      <Sidebar collapsed={collapsed} onToggle={() => setCollapsed(!collapsed)} />
      <main
        className={`transition-all duration-200 ${collapsed ? 'ml-16' : 'ml-64'}`}
      >
        <div className="p-6">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
